var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8096 4.69555C47.0139 5.49204 45.0838 6.03031 43.0584 6.27235C45.1255 5.03302 46.7136 3.07062 47.4612 0.732153C45.5262 1.87983 43.3832 2.71315 41.1022 3.16213C39.2756 1.21595 36.6733 0 33.793 0C28.2628 0 23.7788 4.48343 23.7788 10.0136C23.7788 10.7984 23.8675 11.5627 24.0383 12.2957C15.7157 11.8781 8.33695 7.8914 3.39808 1.83286C2.53605 3.31182 2.04223 5.03197 2.04223 6.86721C2.04223 10.3414 3.81003 13.4065 6.49707 15.2024C4.85571 15.1501 3.31144 14.6998 1.96145 13.9497C1.96049 13.9916 1.96049 14.0334 1.96049 14.0756C1.96049 18.9275 5.41231 22.9747 9.99325 23.8947C9.15301 24.1236 8.26833 24.2461 7.35506 24.2461C6.7098 24.2461 6.08249 24.1831 5.47094 24.0665C6.74529 28.0446 10.4434 30.94 14.8255 31.0205C11.3983 33.7066 7.0805 35.3075 2.38877 35.3075C1.58048 35.3075 0.783393 35.2599 0 35.1673C4.43161 38.0086 9.69532 39.6667 15.3504 39.6667C33.7694 39.6667 43.842 24.4078 43.842 11.1748C43.842 10.7407 43.8322 10.3088 43.8128 9.87922C45.7695 8.46734 47.4673 6.70371 48.8096 4.69555Z",
    fill: "#796F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.c4f1dfa00299879888d7d32450364fb3.svg";
export { ForwardRef as ReactComponent };